export const createPreferencesSlice = (set) => ({
    language: 'en',
    notificationsEnabled: true,
    setLanguage: (language) => set({ language }),
    toggleNotifications: () => set((state) => ({
        notificationsEnabled: !state.notificationsEnabled,
    })),
});
//# sourceMappingURL=preferencesSlice.js.map